(() => {
  if (window.ByteStoreSupport) return;
  const groupFor = element => element.closest('[data-bs-support-product]');
  const isBusy = group => group?.closest('[data-bs-product]')?.dataset.updating === 'true';
  let sharing = false;
  function publicProductURL(group) {
    if (!group || isBusy(group)) return null;
    try {
      const origin = new URL(group.dataset.publicOrigin);
      if (origin.protocol !== 'https:' || /^(localhost|127\.|0\.|\[::1\])/.test(origin.hostname) || origin.hostname.endsWith('.shopifypreview.com')) return null;
      const url = new URL(group.dataset.productPath, origin.origin);
      if (url.origin !== origin.origin || !url.pathname.includes('/products/')) return null;
      url.search = '';
      url.hash = '';
      const root = group.closest('[data-bs-product]');
      const variant = root ? root.dataset.variantId : group.dataset.variantId;
      if (/^\d+$/.test(variant || '')) url.searchParams.set('variant', variant);
      return url.href;
    } catch { return null; }
  }
  function assistanceURL(link, group) {
    const url = publicProductURL(group);
    if (!url || !/^\d{8,15}$/.test(link.dataset.whatsappNumber || '')) return null;
    const message = [link.dataset.whatsappMessage, group.dataset.productTitle, group.dataset.variantTitle, url].filter(Boolean).join('\n');
    return 'https://wa.me/' + link.dataset.whatsappNumber + '?text=' + encodeURIComponent(message);
  }
  function syncBusy(root) {
    const busy = root.dataset.updating === 'true';
    root.querySelectorAll('[data-bs-share]').forEach(button => { button.disabled = busy || sharing; });
    root.querySelectorAll('[data-bs-product-assistance]').forEach(link => {
      if (busy) { link.setAttribute('aria-disabled', 'true'); link.setAttribute('tabindex', '-1'); }
      else { link.removeAttribute('aria-disabled'); link.removeAttribute('tabindex'); }
    });
  }
  function manualCopy(group, url) {
    const fallback = group.querySelector('[data-bs-share-fallback]');
    const field = group.querySelector('[data-bs-share-link]');
    if (!fallback || !field) return;
    field.value = url;
    fallback.hidden = false;
    window.ByteStore?.announce(group.dataset.copyError);
    field.focus();
    field.select();
  }
  document.addEventListener('click', async event => {
    const share = event.target.closest('[data-bs-share]');
    const assistance = event.target.closest('[data-bs-product-assistance]');
    if (!share && !assistance) return;
    const group = groupFor(share || assistance);
    if (assistance) {
      const href = assistanceURL(assistance, group);
      if (!href) event.preventDefault();
      else assistance.href = href;
      return;
    }
    event.preventDefault();
    if (sharing) return;
    const url = publicProductURL(group);
    if (!url) return;
    sharing = true;
    share.disabled = true;
    const shopName = (group.dataset.shopName || 'BYTESTORE HN').trim().toUpperCase();
    const productLabel = [group.dataset.productTitle, group.dataset.variantTitle].filter(Boolean).join(' — ');
    const data = { title: productLabel + ' | ' + shopName, text: shopName + '\n' + productLabel, url };
    try {
      if (typeof navigator.share === 'function') {
        try {
          if (typeof navigator.canShare !== 'function' || navigator.canShare(data)) {
            await navigator.share(data);
            return;
          }
        } catch (error) { if (error?.name === 'AbortError' || error?.name === 'InvalidStateError') return; }
      }
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(url);
        const fallback = group.querySelector('[data-bs-share-fallback]');
        if (fallback) fallback.hidden = true;
        window.ByteStore?.announce(group.dataset.copied);
      } catch { if (group.isConnected) manualCopy(group, url); }
    } finally {
      sharing = false;
      document.querySelectorAll('[data-bs-share]').forEach(button => { button.disabled = isBusy(groupFor(button)); });
    }
  });
  document.addEventListener('click', event => {
    const field = event.target.closest('[data-bs-share-link]');
    if (field) field.select();
  });
  const observer = new MutationObserver(records => {
    records.forEach(record => { if (record.target.matches('[data-bs-product]')) syncBusy(record.target); });
  });
  observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['data-updating'] });
  document.querySelectorAll('[data-bs-product]').forEach(syncBusy);
  let floatingFrame = 0;
  function updateFloating() {
    floatingFrame = 0;
    const launcher = document.querySelector('[data-bs-whatsapp-float]');
    if (!launcher) return;
    const bounds = launcher.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return;
    const bubble = launcher.querySelector('.bs-whatsapp-tooltip')?.getBoundingClientRect();
    const visibleBounds = bubble?.width ? [bounds, bubble] : [bounds];
    const controls = document.querySelectorAll('.add-button, .checkout-button, [name="checkout"], .shopify-payment-button__button, .bsn-form button[type="submit"], #bs-toast:not(:empty)');
    const overlaps = [...controls].some(control => {
      const rect = control.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && visibleBounds.some(area => rect.bottom > area.top - 8 && rect.top < area.bottom + 8 && rect.right > area.left - 8 && rect.left < area.right + 8);
    });
    launcher.classList.toggle('is-obscured', overlaps);
    if (overlaps) { launcher.setAttribute('aria-hidden', 'true'); launcher.setAttribute('tabindex', '-1'); }
    else { launcher.removeAttribute('aria-hidden'); launcher.removeAttribute('tabindex'); }
  }
  const scheduleFloating = () => { if (!floatingFrame) floatingFrame = requestAnimationFrame(updateFloating); };
  document.addEventListener('scroll', scheduleFloating, { passive: true, capture: true });
  ['close', 'focusin', 'focusout'].forEach(name => document.addEventListener(name, scheduleFloating, true));
  window.addEventListener('resize', scheduleFloating, { passive: true });
  ['bs:product:updated', 'bs:content:updated', 'shopify:section:load'].forEach(name => document.addEventListener(name, scheduleFloating));
  const resize = new ResizeObserver(scheduleFloating);
  resize.observe(document.body);
  const toast = document.getElementById('bs-toast');
  if (toast) new MutationObserver(scheduleFloating).observe(toast, { childList: true, subtree: true, characterData: true });
  scheduleFloating();
  window.ByteStoreSupport = { publicProductURL };
})();
